import {
  Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef
} from '@angular/core';

@Component({
  selector: 'axis-fileupoad-alert',
  template: `
        <axis-alert data-kind="danger" [timeOut]="5000" type="notification" (onClose)="closeAlert()"
          [dismissible]="true" #fileuploadAlertComponent>
          <axis-notification>
            <div [innerHTML]="invalidFileMsg"></div>
          </axis-notification>
        </axis-alert>
      `
})
export class FileuploadAlertComponent implements OnInit {
  public invalidFileMsg: any;
  @ViewChild('fileuploadAlertComponent') fileuploadAlertComponent: any;

  constructor(private el: ElementRef, private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    setTimeout(() => {
      this.fileuploadAlertComponent.openAlert();
       this.changeDetectorRef.detectChanges();
    });
  }
  closeAlert() {
    if (this.el.nativeElement.parentElement) {
      this.el.nativeElement.parentElement.removeChild(this.el.nativeElement);
    }
  }
}
